import React from 'react'
import { Tab, Nav } from "react-bootstrap";
import VolumePage from './Volume';
import GroupPage from './Group';
import TitlePage from './Title';

function VolumeTitleGroup() {
    
    const tabData = [
    { name: "RSN Volume", content: <VolumePage /> },
    { name: "RSN Group", content: <GroupPage /> },
    { name: "IPSS Title", content: <TitlePage /> },
  ];

  return (
    <div className='card'>
      <div className="custom-tab-1">
        <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
          <Nav
            as="ul"
            className="nav-pills mb-2 light border-bottom px-4 pt-3"
          >
            {tabData.map((tab, i) => (
              <Nav.Item as="li" key={i}>
                <Nav.Link
                  eventKey={tab.name.toLowerCase()}
                  className="pb-3 fw-semibold fs-5"
                >
                  {tab.name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Tab.Content className="">
            {tabData.map((tab, i) => (
              <Tab.Pane eventKey={tab.name.toLowerCase()} key={i}>
                {tab.content}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </div>
      </div>
  )
}

export default VolumeTitleGroup
